import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Clock, 
  Instagram, 
  Youtube, 
  Send,
  User,
  MessageCircle,
  CheckCircle 
} from 'lucide-react';

const Contato = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    assunto: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: '62cdad80-def5-4902-8f36-b9b9e1a19746', // Substitua pela sua access key do Web3Forms
          to_email: 'contato@mevambrasilia.org',
          from_name: formData.nome,
          subject: `[MEVAM Brasília] ${formData.assunto}`,
          nome: formData.nome,
          email: formData.email,
          telefone: formData.telefone || 'Não informado',
          assunto: formData.assunto,
          message: formData.mensagem,
        }),
      });

      const result = await response.json();

      if (result.success) {
        setIsSubmitted(true);
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          assunto: '',
          mensagem: ''
        });
      } else {
        alert('Erro ao enviar mensagem. Por favor, tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
      alert('Erro ao enviar mensagem. Por favor, tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const contatos = [
    {
      icon: Phone,
      titulo: 'Telefone',
      info: '(61) 99818-7484',
      link: 'tel:61998187484',
      descricao: 'Ligue para nós durante o horário comercial'
    },
    {
      icon: Mail,
      titulo: 'E-mail',
      info: 'contato@mevambrasilia.org',
      link: 'mailto:contato@mevambrasilia.org',
      descricao: 'Envie sua mensagem por e-mail'
    },
    {
      icon: MapPin,
      titulo: 'Endereço',
      info: 'QNN 2 Loja 07, Ceilândia, Brasília - DF, 72220-028',
      link: 'https://www.google.com/maps/place/MEVAM+CEIL%C3%82NDIA+-+BRAS%C3%8DLIA/@-15.8218592,-48.111794,17z/data=!3m1!4b1!4m6!3m5!1s0x935bcd3d028147cd:0x2752d7d8d39a3810!8m2!3d-15.8218592!4d-48.111794!16s%2Fg%2F11p_7lgmv7?entry=ttu&g_ep=EgoyMDI1MTAwMS4wIKXMDSoASAFQAw%3D%3D',
      descricao: 'Clique para abrir no Google Maps'
    }
  ];

  const horarios = [
    { dia: 'Domingo', horario: 'Culto às 19:00' },
    { dia: 'Terça-feira', horario: 'PG/Academy às 19:30' },
    { dia: 'Quinta-feira', horario: 'Culto Profético às 20:00' },
    
  ];

  const redesSociais = [
    {
      icon: Instagram,
      nome: 'Instagram',
      link: 'https://www.instagram.com/mevam.brasilia/',
      cor: 'hover:text-pink-600'
    },
    {
      icon: Youtube,
      nome: 'YouTube',
      link: 'https://www.youtube.com/@mevam.brasilia',
      cor: 'hover:text-red-600'
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-[#030B2E] via-[#030B2E] to-[#17E6B3]/20 text-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Entre em Contato
            </h1>
            <p className="text-xl md:text-2xl text-[#B8C4E3]">
              Estamos aqui para ouvir você. Tire suas dúvidas, envie sugestões ou venha nos visitar!
            </p>
          </motion.div>
        </div>
      </section>

      {/* Informações de Contato */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {contatos.map((contato, index) => {
              const IconComponent = contato.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-6 text-center hover:shadow-2xl hover:shadow-[#17E6B3]/20 transition-all duration-300"
                >
                  <IconComponent className="text-[#17E6B3] mx-auto mb-4" size={48} />
                  <h3 className="text-xl font-semibold text-white mb-3">
                    {contato.titulo}
                  </h3>
                  <a 
                    href={contato.link}
                    className="text-[#17E6B3] hover:text-[#17E6B3]/80 font-semibold text-lg block mb-2 transition-colors"
                  >
                    {contato.info}
                  </a>
                  <p className="text-[#B8C4E3]">{contato.descricao}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Formulário e Informações */}
      <section className="section-padding bg-[#030B2E]">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Formulário */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-white mb-6">
                Envie uma Mensagem
              </h2>
              
              {isSubmitted ? (
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-8 text-center"
                >
                  <CheckCircle className="text-[#17E6B3] mx-auto mb-4" size={64} />
                  <h3 className="text-2xl font-bold text-white mb-4">
                    Mensagem Enviada!
                  </h3>
                  <p className="text-[#B8C4E3] mb-6">
                    Obrigado por entrar em contato conosco. Retornaremos em breve!
                  </p>
                  <button
                    onClick={() => setIsSubmitted(false)}
                    className="bg-[#17E6B3] hover:bg-[#17E6B3]/90 text-[#030B2E] font-semibold py-3 px-8 rounded-xl transition-all shadow-lg shadow-[#17E6B3]/30"
                  >
                    Enviar Nova Mensagem
                  </button>
                </motion.div>
              ) : (
                <form onSubmit={handleSubmit} className="bg-white rounded-xl p-6 space-y-6 shadow-xl">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="nome" className="block text-[#030B2E] font-semibold mb-2">
                        Nome Completo *
                      </label>
                      <div className="relative">
                        <User className="absolute left-3 top-3 text-gray-400" size={20} />
                        <input
                          type="text"
                          id="nome"
                          name="nome"
                          value={formData.nome}
                          onChange={handleInputChange}
                          required
                          className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#17E6B3] focus:border-transparent transition-all"
                          placeholder="Seu nome completo"
                        />
                      </div>
                    </div>
                    
                    <div>
                      <label htmlFor="telefone" className="block text-[#030B2E] font-semibold mb-2">
                        Telefone
                      </label>
                      <div className="relative">
                        <Phone className="absolute left-3 top-3 text-gray-400" size={20} />
                        <input
                          type="tel"
                          id="telefone"
                          name="telefone"
                          value={formData.telefone}
                          onChange={handleInputChange}
                          className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#17E6B3] focus:border-transparent transition-all"
                          placeholder="(61) 99999-9999"
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-[#030B2E] font-semibold mb-2">
                      E-mail *
                    </label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-3 text-gray-400" size={20} />
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#17E6B3] focus:border-transparent transition-all"
                        placeholder="seu@email.com"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label htmlFor="assunto" className="block text-[#030B2E] font-semibold mb-2">
                      Assunto *
                    </label>
                    <select
                      id="assunto"
                      name="assunto"
                      value={formData.assunto}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#17E6B3] focus:border-transparent transition-all"
                    >
                      <option value="">Selecione um assunto</option>
                      <option value="visita">Quero Visitar a Igreja</option>
                      <option value="oracao">Pedido de Oração</option>
                      <option value="ministerio">Participar de Ministério</option>
                      <option value="batismo">Batismo</option>
                      <option value="casamento">Casamento</option>
                      <option value="outros">Outros</option>
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="mensagem" className="block text-[#030B2E] font-semibold mb-2">
                      Mensagem *
                    </label>
                    <div className="relative">
                      <MessageCircle className="absolute left-3 top-3 text-gray-400" size={20} />
                      <textarea
                        id="mensagem"
                        name="mensagem"
                        value={formData.mensagem}
                        onChange={handleInputChange}
                        required
                        rows={5}
                        className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#17E6B3] focus:border-transparent transition-all resize-vertical"
                        placeholder="Escreva sua mensagem aqui..."
                      ></textarea>
                    </div>
                  </div>
                  
                  <motion.button
                    type="submit"
                    disabled={isSubmitting}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="w-full bg-[#17E6B3] hover:bg-[#17E6B3]/90 disabled:opacity-50 disabled:cursor-not-allowed text-[#030B2E] py-4 px-6 rounded-lg font-semibold transition-all duration-300 flex items-center justify-center shadow-lg shadow-[#17E6B3]/30"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#030B2E] mr-2"></div>
                        Enviando...
                      </>
                    ) : (
                      <>
                        <Send className="mr-2" size={20} />
                        Enviar Mensagem
                      </>
                    )}
                  </motion.button>
                </form>
              )}
            </motion.div>

            {/* Informações Adicionais */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="space-y-8"
            >
              {/* Horários */}
              <div className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-6">
                <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                  <Clock className="mr-3 text-[#17E6B3]" size={24} />
                  Horários de Atividades
                </h3>
                <div className="space-y-4">
                  {horarios.map((item, index) => (
                    <div key={index} className="flex justify-between items-center py-2 border-b border-[#17E6B3]/10 last:border-0">
                      <span className="font-semibold text-[#B8C4E3]">{item.dia}</span>
                      <span className="text-[#17E6B3] font-semibold">{item.horario}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-6 p-4 bg-gradient-to-r from-[#17E6B3] to-[#17E6B3]/80 text-[#030B2E] rounded-lg shadow-lg shadow-[#17E6B3]/20">
                  <p className="text-center font-semibold">
                    🙏 Você é sempre bem-vindo em nossa casa!
                  </p>
                </div>
              </div>

              {/* Redes Sociais */}
              <div className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-6">
                <h3 className="text-2xl font-bold text-white mb-6">
                  Siga-nos nas Redes Sociais
                </h3>
                <div className="flex justify-center space-x-6">
                  {redesSociais.map((rede, index) => {
                    const IconComponent = rede.icon;
                    return (
                      <motion.a
                        key={index}
                        href={rede.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{ scale: 1.1, y: -5 }}
                        className="p-4 bg-[#17E6B3]/20 rounded-full text-[#17E6B3] hover:bg-[#17E6B3] hover:text-[#030B2E] transition-all duration-300"
                      >
                        <IconComponent size={32} />
                      </motion.a>
                    );
                  })}
                </div>
                <p className="text-center text-[#B8C4E3] mt-4">
                  Acompanhe nossos eventos, mensagens e momentos especiais
                </p>
              </div>

              {/* Como Chegar */}
              <div className="bg-white/5 backdrop-blur-sm border border-[#17E6B3]/20 rounded-xl p-6">
                <h3 className="text-2xl font-bold text-white mb-4 flex items-center">
                  <MapPin className="mr-3 text-[#17E6B3]" size={24} />
                  Como Chegar
                </h3>
                <div className="space-y-3 text-[#B8C4E3]">
                  <p><strong className="text-white">Endereço:</strong> QNN 2 Loja 07, Ceilândia, Brasília - DF, 72220-028</p>
                  <p><strong className="text-white">Cidade:</strong> Brasília - DF</p>
                  <p><strong className="text-white">Estacionamento:</strong> Gratuito no local</p>
                  <p><strong className="text-white">Transporte:</strong> Acesso fácil de ônibus</p>
                </div>
                <motion.a
                  href="https://www.google.com/maps/place/MEVAM+CEIL%C3%82NDIA+-+BRAS%C3%8DLIA/@-15.8218592,-48.111794,17z/data=!3m1!4b1!4m6!3m5!1s0x935bcd3d028147cd:0x2752d7d8d39a3810!8m2!3d-15.8218592!4d-48.111794!16s%2Fg%2F11p_7lgmv7?entry=ttu&g_ep=EgoyMDI1MTAwMS4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="w-full mt-4 bg-[#17E6B3] hover:bg-[#17E6B3]/90 text-[#030B2E] font-semibold py-3 px-6 rounded-lg transition-all text-center block shadow-lg shadow-[#17E6B3]/30"
                >
                  Ver no Mapa
                </motion.a>
                <div className="mt-6 rounded-lg overflow-hidden shadow-lg">
                  <iframe
                    title="Mapa MEVAM Ceilândia"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1227.964964073624!2d-48.111794!3d-15.8218592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935bcd3d028147cd%3A0x2752d7d8d39a3810!2sMEVAM%20CEIL%C3%82NDIA%20-%20BRAS%C3%8DLIA!5e0!3m2!1spt-BR!2sbr!4v1696612345678!5m2!1spt-BR!2sbr"
                    width="100%"
                    height="220"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section-padding bg-gradient-to-br from-[#030B2E] to-[#17E6B3]/20 text-white">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Venha Fazer Parte da Nossa Família
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto text-[#B8C4E3]">
              Nossa porta está sempre aberta para você. Venha como está, 
              Deus tem algo especial preparado para sua vida.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              
              <motion.a
                href="https://wa.me/5561998187484"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="border-2 border-white text-white hover:bg-white hover:text-[#030B2E] font-semibold py-3 px-8 rounded-xl transition-all inline-flex items-center justify-center"
              >
                <MessageCircle className="mr-2" size={20} />
                WhatsApp
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contato;